import { FareModalProps } from '@/src/components/desktop/srp/fareFamily/types'
import { Box, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import FareFamilyMobile from '.'

const FareFamilyMobileDrawer = ({ ...fareModalProps }: FareModalProps) => {
    const tFareFamily = useTranslations('fareFamily')
    return (
            <Box
                sx={{
                    flex: 1,
                    minHeight: 0,
                    width: '100%',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                {/* Header with close button */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexShrink: 0,
                    }}
                >
                    {/* Center: Heading */}
                    <Box sx={{ flexGrow: 1, textAlign: 'center' }}>
                        <Typography variant="h6" className="font-bold text-xl leading-8">
                            {tFareFamily('fareFamilyTitle')}
                        </Typography>
                    </Box>
                </Box>

                <FareFamilyMobile {...fareModalProps} />
            </Box>
    )
}

export default FareFamilyMobileDrawer
